<template>
	<div class="resource-dtails">
		<div class="title">
			<span>{{resourceDetails.name}}</span>
			<span class="viewCount">发布日期：{{resourceDetails.createTime}}&nbsp;&nbsp;&nbsp;&nbsp;浏览次数：45次</span>
		</div>
		<el-divider></el-divider>
		<div class="details-text">
			<div v-if="resourceDetails.fileType=='img'">
				<el-image :src='resourceDetails.fileUrl'></el-image>
			</div>
			<div v-else-if="resourceDetails.fileType=='video'">
				<video :src='resourceDetails.fileUrl' controls style="width: 100%;"></video>
			</div>
			<div v-else>
				<iframe class="file-pdf" src="/file/1.pdf" frameborder="0"></iframe>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			resourceDetails: {
				type: Object
			}
		},
		created() {
			// console.log(this.projectDetails)
		}
	}
</script>

<style lang="scss">
	.resource-dtails {

		.title {
			line-height: 50px;
			font-weight: bold;

			.viewCount {
				float: right;
				color: #4b4b4b;
				font-size: 14px;
				font-weight: 100;
			}
		}

		.el-divider {
			margin: 0;
			margin-bottom: 20px;
		}

		.details-text {
			// text-align: center;
			// text-indent: 2em;

			.file-pdf {
				width: 100%;
				height: calc(100vh - 150px);
			}
		}
	}
</style>